<script setup>
/**
 * The gold seal with a word beside it: "Published", "Shared with your coven",
 * "Link copied". The same wax seal the gift uses (2026-10-19). `pressed`
 * plays the seal's press once when it appears.
 */
defineProps({
  label: { type: String, required: true },
  pressed: { type: Boolean, default: true },
  wide: { type: Boolean, default: false },
})
</script>

<template>
  <p class="gs" :class="{ wide, pressed }" role="status">
    <span class="gs-seal" aria-hidden="true">✓</span><span class="gs-word">{{ label }}</span>
  </p>
</template>

<style scoped>
.gs {
  display: inline-flex; align-items: center; justify-content: center; gap: 10px; margin: 0;
  min-height: 48px; padding: 0 22px 0 8px; border-radius: 999px; background: #fff7e3; border: 1px solid #e7c983;
  font: 700 15px/1.2 Inter, system-ui, sans-serif; color: #5a3f0f; max-width: 100%;
}
.gs.wide { display: flex; width: 100%; min-height: 56px; padding: 0 18px; }
.gs-word { min-width: 0; overflow-wrap: anywhere; }
.gs-seal {
  flex: 0 0 auto; width: 34px; height: 34px; border-radius: 50%; display: grid; place-items: center;
  background: radial-gradient(circle at 35% 30%, #f3d98f, #c9a94e 45%, #8a6a2a 100%); color: #5a3f0f;
  font: 700 14px Inter, system-ui, sans-serif; box-shadow: 0 3px 8px rgba(42, 24, 69, .35), inset 0 0 0 3px rgba(255, 240, 200, .35);
}
.gs.pressed .gs-seal { animation: gs-press .42s cubic-bezier(.2, .9, .3, 1.3) both; }
@keyframes gs-press { 0% { transform: scale(1.5) rotate(-18deg); opacity: 0; } 100% { transform: none; opacity: 1; } }
@media (prefers-reduced-motion: reduce) { .gs.pressed .gs-seal { animation: none; } }
</style>
